import { action } from '@reatom/framework'

import type { CurrencyModel } from '@root/entities/currency'

// eslint-disable-next-line @reatom/unit-naming-rule
export const openSplashPointsInfoFlowEvent = action<CurrencyModel>(
  'openSplashPointsInfoFlowEvent',
)
